import type { ISgwtHelpCenterCategory } from '../sgwt-help-center.types';

export function getCategoryTitleById(categories: ISgwtHelpCenterCategory[] | null, id: string): string {
  let ret = '';
  if (!categories || !id) {
    return ret;
  }
  const results: ISgwtHelpCenterCategory[] = categories.filter((category: ISgwtHelpCenterCategory): boolean => category.id === id);
  if (results && results.length === 1) {
    return results[0].title;
  }
  // @TODO
  // categories.forEach((category: ISgwtHelpCenterCategory): void => {});
  // no break keyword, find a more efficient way...
  for (const category of categories) {
    if (!ret && category.subCategories && Array.isArray(category.subCategories)) {
      ret = getCategoryTitleById(category.subCategories, id);
      if (ret) {
        return ret;
      }
    }
  }
  return ret;
}
